var map = {
	"./background-we-re-here-to-help.svg": "6nlp",
	"./bg-brand-confetti-repeat.svg": "vuNo",
	"./icon-national-relay-service.png": "rho4",
	"./tube-desktop@2x.png": "G7D1",
	"./tube-mobile@2x.png": "DdBs"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8XGs";